// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { IconChevronLeft } from "../components/icons.jsx";
import { IconSparkles } from "../components/icons.jsx";
import { IconCoin } from "../components/icons.jsx";
import { IconStarFilledFilled } from "../FishingArcade.jsx";
import { IconArrowRight } from "../components/icons.jsx";
export const $i = [{
  coins: 30,
  price: "20 Stars"
}, {
  coins: 100,
  price: "50 Stars"
}, {
  coins: 500,
  price: "250 Stars"
}, {
  coins: 1e3,
  price: "500 Stars"
}, {
  coins: 2e3,
  price: "1 000 Stars"
}, {
  coins: 1e4,
  price: "5 000 Stars"
}];
export function WalletPage({
  onBack: u,
  onBuy: o
}) {
  const [m, r] = React.useState($i[1].coins),
    [g, j] = React.useState(!1),
    B = $i.find(y => y.coins === m) || $i[0],
    U = window.Telegram?.WebApp?.BackButton;
  React.useEffect(() => {
    if (U) return U.show(), U.onClick(u), () => {
      U.offClick(u), U.hide();
    };
  }, [U, u]);
  const N = async () => {
    j(!0);
    try {
      await o(B.coins);
    } finally {
      j(!1);
    }
  };
  return jsxRuntime.jsxs("section", {
    className: "mc-wallet-page",
    children: [!U && jsxRuntime.jsxs("button", {
      className: "mc-wallet-back",
      onClick: u,
      children: [jsxRuntime.jsx(IconChevronLeft, {}), "Назад"]
    }), jsxRuntime.jsxs("article", {
      className: "mc-wallet-intro",
      children: [jsxRuntime.jsxs("span", {
        className: "mc-wallet-intro-icon",
        children: [jsxRuntime.jsx(IconSparkles, {}), jsxRuntime.jsx(IconSparkles, {}), jsxRuntime.jsx(IconSparkles, {})]
      }), jsxRuntime.jsx("h1", {
        children: "Пополнение MetaCoin"
      }), jsxRuntime.jsx("p", {
        children: "Покупайте MetaCoin за Telegram Stars"
      })]
    }), jsxRuntime.jsxs("section", {
      className: "mc-wallet-section",
      children: [jsxRuntime.jsxs("div", {
        className: "mc-package-preview",
        children: [jsxRuntime.jsxs("div", {
          children: [jsxRuntime.jsx("b", {
            children: B.coins.toLocaleString("ru-RU")
          }), jsxRuntime.jsx(IconCoin, {})]
        }), jsxRuntime.jsxs("strong", {
          children: [jsxRuntime.jsx(IconStarFilledFilled, {}), B.price]
        }), jsxRuntime.jsx("span", {
          children: "Выберите количество MetaCoin"
        })]
      }), jsxRuntime.jsx("div", {
        className: "mc-package-grid",
        children: $i.map(y => jsxRuntime.jsxs("button", {
          className: m === y.coins ? "mc-package active" : "mc-package",
          onClick: () => r(y.coins),
          children: [jsxRuntime.jsxs("b", {
            children: [y.coins.toLocaleString("ru-RU"), " ", jsxRuntime.jsx("i", {
              children: "MC"
            })]
          }), jsxRuntime.jsxs("span", {
            children: [jsxRuntime.jsx(IconStarFilledFilled, {}), y.price]
          })]
        }, y.coins))
      })]
    }), jsxRuntime.jsxs("button", {
      className: "mc-wallet-buy",
      disabled: g,
      onClick: () => {
        N();
      },
      children: [g ? "Открываем счёт…" : "Купить MetaCoin", " ", jsxRuntime.jsx(IconArrowRight, {})]
    }), jsxRuntime.jsx("p", {
      className: "mc-wallet-note",
      children: "Оплата проходит через Telegram Stars."
    })]
  });
}
